import type { CourseModel, ParticipantExtendedModel } from '../../data/types';

import type { DesktopModel, ParticipantModel } from 'Api';

export interface SwitchableDesktop {
  id: string;
  userId: string;
  displayName: string;
  avatarColor?: string;
  avatar?: string;
  desktop: DesktopModel;
  isParticipantDesktop: boolean;
  isTrainerDesktop: boolean;
  isFreshStartDesktop: boolean;
  isMyDesktop: boolean;
}

export const getSwitchableDesktops = (
  course: CourseModel,
  currentUserId: string,
  filteredParticipants: ParticipantExtendedModel[],
  trainer: ParticipantModel
): SwitchableDesktop[] => {
  const desktops: SwitchableDesktop[] = [];

  // if (trainer.desktop) {
  //   const isCurrentUserTrainer = course.isTrainer ?? false;
  //   desktops.push({
  //     id: `trainer-${trainer.id}`,
  //     userId: trainer.id,
  //     displayName: trainer.displayName || 'Trainer',
  //     avatarColor: trainer.avatarColor,
  //     avatar: trainer.avatar,
  //     desktop: trainer.desktop,
  //     isParticipantDesktop: false,
  //     isTrainerDesktop: true,
  //     isFreshStartDesktop: false,
  //     isMyDesktop: isCurrentUserTrainer
  //   });
  // }

  // if (course.freshStartDesktop) {
  //   desktops.push({
  //     id: `freshstart-${course.id}`,
  //     userId: 'freshstart',
  //     displayName: 'Fresh Start',
  //     desktop: course.freshStartDesktop,
  //     isParticipantDesktop: false,
  //     isTrainerDesktop: false,
  //     isFreshStartDesktop: true,
  //     isMyDesktop: false
  //   });
  // }

  filteredParticipants.forEach(participant => {
    if (participant.desktop?.isRunning) {
      desktops.push({
        id: `participant-${participant.id}`,
        userId: participant.id,
        displayName: participant.displayName || 'Participant',
        avatarColor: participant.avatarColor,
        avatar: participant.avatar,
        desktop: participant.desktop,
        isParticipantDesktop: true,
        isTrainerDesktop: false,
        isFreshStartDesktop: false,
        isMyDesktop: participant.id === currentUserId
      });
    }
  });

  return desktops;
};

export const getNextDesktop = (
  switchableDesktops: SwitchableDesktop[],
  currentIndex: number
): SwitchableDesktop | null => {
  if (switchableDesktops.length === 0) {
    return null;
  }

  if (switchableDesktops.length === 1) {
    return switchableDesktops[0];
  }

  const nextIndex = (currentIndex + 1) % switchableDesktops.length;
  return switchableDesktops[nextIndex];
};

export const getPreviousDesktop = (
  switchableDesktops: SwitchableDesktop[],
  currentIndex: number
): SwitchableDesktop | null => {
  if (switchableDesktops.length === 0) {
    return null;
  }

  if (switchableDesktops.length === 1) {
    return switchableDesktops[0];
  }

  const prevIndex = currentIndex === 0 ? switchableDesktops.length - 1 : currentIndex - 1;
  return switchableDesktops[prevIndex];
};

export const areSwitchableDesktopListsEqual = (
  list1: SwitchableDesktop[],
  list2: SwitchableDesktop[]
): boolean => {
  if (list1.length !== list2.length) {
    return false;
  }

  return JSON.stringify(list1) === JSON.stringify(list2);
};
